import { Component, OnInit, Input } from '@angular/core';
import { ParamsService, enumToArray } from 'elbuild-ui-lib-core';
import { TextBlockEntity } from 'toolbandi-ui-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-textblock-list-filters',
	templateUrl: './textblock-list-filters.component.html',
	styleUrls: ['./textblock-list-filters.component.scss']
})
export class TextblockListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;

	@Input()
	tenderid: number;

	textblockTypes = enumToArray(TextBlockEntity);

	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
	) {
		super(router, _route, paramsService);



	}

	ngOnInit() {

		this.setParams();

	}

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.keyword = undefined;
		super.resetSearch();
		this.setParams()
	}

	search(keeppage?: boolean) {
		super.search(keeppage);
		this.setParams();
	}

	setParams() {
		if (this.tenderid) {
			this.searchparams.addSimpleFilter('tenderid', this.tenderid)
		}
		/*if (this.active) {
			this.searchparams.addSimpleFilter('status', CompanyStatus.ACTIVE);
		} else {
			this.searchparams.removeSimpleFilter('status');
		}*/

	}

}
